var map = {
	"./LTC clearance 1.xlsx": "./src/assets/uploadExampleFiles/LTC clearance 1.xlsx",
	"./LTC clearance 2.xlsx": "./src/assets/uploadExampleFiles/LTC clearance 2.xlsx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/uploadExampleFiles sync recursive ^\\.\\/.*$";